import {styled} from "@mui/material";

export const DRAWER_SIDE_PADDING = '20px'

export const DrawerContent = styled('div')<{padded?: boolean}>`
  width: ${props => props.padded? `calc(440px - 2 * ${DRAWER_SIDE_PADDING})` : '440px'};
  padding: ${props => props.padded? `30px ${DRAWER_SIDE_PADDING}` : '0'};
  height: calc(100% - 100px);
  position: relative;
`